export const _state = {
    isOpenRegulationFilterDrawer: false,
    isOpenTaskFilterDrawer: false,
};

export function drawerReducer(state = _state, action) {

    switch (action.type) {

        case 'REGULATION_FILTER_DRAWER_OPEN':
            return {
                ...state,
                isOpenRegulationFilterDrawer: true,
            };

        case 'REGULATION_FILTER_DRAWER_CLOSE':
            return {
                ...state,
                isOpenRegulationFilterDrawer: false,
            };

        case 'TASK_FILTER_DRAWER_OPEN':
            return {
                ...state,
                isOpenTaskFilterDrawer: true,
            };

        case 'TASK_FILTER_DRAWER_CLOSE':
            return {
                ...state,
                isOpenTaskFilterDrawer: false,
            };

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/drawer.js